import { Switch, Route, Redirect } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import SessionExpiredModal from './components/ui/SessionExpiredModal';
import SignInPage from './pages/sign-in/SignInPage';
import ResetPasswordPage from './pages/sign-in/ResetPasswordPage';
import SetPasswordPage from './pages/sign-in/SetPasswordPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import AgreementFormPage from './pages/agreement/AgreementFormPage';

const ProtectedRoute = ({ children }) => {
    const { currentUser } = useAuth();
    return currentUser ? children : <Redirect to="/signin" />;
};

function App() {
    return (
        <>
            <SessionExpiredModal />
            <Switch>
                <Route exact path="/"><Redirect to="/dashboard" /></Route>
                <Route exact path="/signin" component={SignInPage} />
                <Route exact path="/resetpassword" component={ResetPasswordPage} />
                <Route exact path="/setpassword/:token" component={SetPasswordPage} />
                <Route exact path="/agreement/:token" component={AgreementFormPage} />
                <Route exact path="/dashboard">
                    <ProtectedRoute><DashboardPage /></ProtectedRoute>
                </Route>
                <Route><Redirect to="/dashboard" /></Route>
            </Switch>
        </>
    );
}

export default App;
